export interface SelectedItemsState {
  selectedItems: {
    inboxItems: string[];
    sentItems: string[];
    draftItems: string[];
    spamItems: string[];
    trashItems: string[];
    allMailItems: string[];
    labelsItems: string[];
  };
}

export interface SelectedItemsAction {
  setInboxItems: (items: string[]) => void;
  setSentItems: (items: string[]) => void;
  setDraftItems: (items: string[]) => void;
  setSpamItems: (items: string[]) => void;
  setTrashItems: (items: string[]) => void;
  setAllMailItems: (items: string[]) => void;
  setLabelsItems: (items: string[]) => void;
  clearSelection: () => void;
  resetState: () => void;
}

export const INITIAL_SELECTED_ITEMS_STATE: SelectedItemsState = {
  selectedItems: {
    inboxItems: [],
    sentItems: [],
    draftItems: [],
    spamItems: [],
    trashItems: [],
    allMailItems: [],
    labelsItems: [],
  },
};

export type SelectedItemsStore = SelectedItemsAction & SelectedItemsState;
